import React from 'react';

// mui
import {
  Box,
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Stack,
} from '@mui/material';

// components
import { Icon } from '@/components/atoms/Icon/Icon';
import { LinkItem } from '@/pwa/molecules/NavDrawer/NavDrawer';
import {
  AccountInfo,
  AccountInfoProps,
} from '@/pwa/atoms/AccountInfo/AccountInfo';

interface NavDesktopProps {
  links: LinkItem[];
  accountInfoProps?: AccountInfoProps;
  activePath?: string;
}

/**
 * NavDesktop component for desktop navigation.
 */
export const NavDesktop = ({
  links,
  accountInfoProps,
  activePath,
}: NavDesktopProps) => {
  return (
    <Stack
      direction='row'
      spacing={0}
      sx={{
        minHeight: 0,
      }}
    >
      <Stack
        sx={{
          gap: 8,
          alignItems: 'center',
          paddingY: 3,
        }}
      >
        {accountInfoProps && (
          <Box
            sx={{
              paddingLeft: 2,
              paddingRight: 3,
            }}
          >
            <AccountInfo {...accountInfoProps} />
          </Box>
        )}
        <List sx={{ width: '100%' }}>
          {links.map((link, index) => (
            <ListItem disablePadding key={index}>
              <ListItemButton
                onClick={link.onClick}
                selected={link.to === activePath}
                sx={{
                  '&.Mui-selected': {
                    backgroundColor: 'transparent',
                    color: 'primary.main',
                    '& .MuiListItemIcon-root': {
                      color: 'primary.main',
                    },
                    '&:hover': {
                      backgroundColor: 'action.hover',
                    },
                  },
                }}
              >
                <ListItemIcon>
                  <Icon icon={link.icon} />
                </ListItemIcon>
                <ListItemText primary={link.label} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Stack>
      <Divider orientation='vertical' flexItem />
    </Stack>
  );
};

NavDesktop.displayName = 'NavDesktop';
export default NavDesktop;
